import gql from "graphql-tag";

export const MY_TIME_SHEET_GET_USERS_SUMMARY_LIST = gql`
  mutation usersSummaryList(
    $page: Int
    $pageSize: Int
    $startTime: Date
    $endTime: Date
    $roleFilters: RoleFilterInput
    $sortField: String
    $sortDirection: String
    $searchField: String
    $searchText: String
    $role: String
    $onlyRequested: Boolean
  ) {
    usersSummaryList(
      page: $page
      pageSize: $pageSize
      startTime: $startTime
      endTime: $endTime
      roleFilters: $roleFilters
      sortField: $sortField
      sortDirection: $sortDirection
      searchField: $searchField
      searchText: $searchText
      role: $role
      onlyRequested: $onlyRequested
    ) {
      rows {
        contractId
        employeeCode
        employeeName
        requestedCost
        requestedDuration
        requests
        _id
        projectName
        clientName
        startTime
        endTime
        duration
      }
      total
      page
      pageSize
      totalPages
      totalRequests
    }
  }
`;
